import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';

import useSelectedRegion from './utils/selectedRegionHook';
import './index.css';
import App from './App';

import * as serviceWorker from './serviceWorker';
import configSlice from './utils/configSlice';

import messages_en from './locales/en.json';
import messages_by from './locales/by.json';
import messages_cr from './locales/cr.json';
import messages_cy from './locales/cy.json';
import messages_cz from './locales/cz.json';
import messages_hu from './locales/hu.json';
import messages_me from './locales/me.json';
import messages_oc from './locales/oc.json';
import messages_pl from './locales/pl.json';
import messages_ro from './locales/ro.json';
import messages_ru from './locales/ru.json';
import messages_sk from './locales/sk.json';
import messages_il from './locales/il.json';

const messages = {
  en: messages_en,
  by: messages_by,
  hr: messages_cr,
  cy: messages_cy,
  cs: messages_cz,
  hu: messages_hu,
  me: messages_me,
  oc: messages_oc,
  pl: messages_pl,
  ro: messages_ro,
  ru: messages_ru,
  sk: messages_sk,
  il: messages_il,
}

const selectedRegion = useSelectedRegion();
const language = (selectedRegion && selectedRegion.toLowerCase()) || 'en';
//const language = navigator.language.split(/[-_]/)[0];

const store = configureStore({
  reducer: combineReducers({
    config: configSlice.reducer,
  }),
});

ReactGA.initialize('UA-118121342-15');

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <IntlProvider locale={language} messages={messages[language] ? messages[language] : messages.en}>
        <App />
      </IntlProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
